import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ClearModal = function ClearModal(_ref) {
  var clearLens = _ref.clearLens,
      open = _ref.open,
      handleClose = _ref.handleClose;
  return /*#__PURE__*/_jsxs(Dialog, {
    open: open,
    onClose: handleClose,
    "data-element": "Dialog",
    "data-component": "ClearModal",
    "data-source-file": "clear-modal.tsx",
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      sx: {
        fontSize: function fontSize(t) {
          return t.typography.h3.fontSize;
        }
      },
      "data-element": "DialogTitle",
      "data-component": "ClearModal",
      "data-source-file": "clear-modal.tsx",
      children: "Clear Lens?"
    }), /*#__PURE__*/_jsx(DialogContent, {
      "data-element": "DialogContent",
      "data-source-file": "clear-modal.tsx",
      children: /*#__PURE__*/_jsx(DialogContentText, {
        "data-element": "DialogContentText",
        "data-source-file": "clear-modal.tsx",
        children: "You will clear this Lens and revert to standard Member View."
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      "data-element": "DialogActions",
      "data-source-file": "clear-modal.tsx",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        onClick: handleClose,
        "data-element": "Button",
        "data-source-file": "clear-modal.tsx",
        children: "No, cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        onClick: function onClick() {
          clearLens();
          handleClose();
        },
        "data-element": "Button",
        "data-source-file": "clear-modal.tsx",
        children: "Yes, clear Lens"
      })]
    })]
  });
};

export default ClearModal;